<template>
  <div class="image-viewer-scroll-counter">
    <a
      id="image-viewer-scroll-counter__previous"
      :class="scrollButtonClasses('previous')"
      @click="previousImage"
    >
      <ArrowLeft />
    </a>
    <span class="image-viewer-scroll-counter__text typo-small-title">
      {{ $t('issues.image_scroll_count', { number: selectedIndex + 1, total: imageCount }) }}
    </span>
    <a
      id="image-viewer-scroll-counter__next"
      :class="scrollButtonClasses('next')"
      @click="nextImage"
    >
      <ArrowRight />
    </a>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import ArrowLeft from '@/images/arrow-left-16.svg';
import ArrowRight from '@/images/arrow-right-16.svg';

const emit = defineEmits(['setCurrentImage']);

const props = defineProps({
  images: { type: Array, default: () => [] },
  selectedIndex: { type: Number, required: true },
});

const imageCount = computed(() => props.images.length);
const nextIndex = computed(() => props.selectedIndex + 1);
const previousIndex = computed(() => props.selectedIndex - 1);
const hasNextImage = computed(() => props.selectedIndex < imageCount.value - 1);
const hasPreviousImage = computed(() => props.selectedIndex > 0);

const scrollButtonClasses = computed(() => {
  return action => {
    const enabled = action == 'previous' ? hasPreviousImage.value : hasNextImage.value;

    return [
      'button',
      'button--light',
      'button--small-long',
      {
        'button--disabled': !enabled,
        'button--dark-color': enabled,
      },
    ];
  };
});

function nextImage() {
  if (hasNextImage.value === true) {
    emit('setCurrentImage', props.images[nextIndex.value]);
  }
}

function previousImage() {
  if (hasPreviousImage.value === true) {
    emit('setCurrentImage', props.images[previousIndex.value]);
  }
}
</script>

<style lang="scss" scoped>
@import '@/stylesheets/global';

.image-viewer-scroll-counter {
  display: flex;
  align-items: center;

  &__text {
    user-select: none;
    text-align: center;
    width: bu(10);
  }
}
</style>
